<template>
	<b-card no-body>
		<b-row class="d-flex align-items-start">
			<!-- LEFT SECTION -->
			<b-col cols="auto" class="p-3">
				<div class="d-flex align-items-center">
					<div class="p-0 mx-2">
						<el-input placeholder="Search by text" v-model="filters.search_txt" @change="getListing()"> <i slot="prefix"
								class="el-input__icon el-icon-search"></i>
						</el-input>
					</div>
				</div>
			</b-col>

			<!-- RIGHT SECTION -->
			<b-col cols="auto" class="ml-auto p-3 mx-2">
				<b-row class="d-flex align-items-center">
					<b-col cols="auto">
						<b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	
		<!-- TABLE LIST -->
		<div class="table-listings">
			<el-table ref="multipleTable" v-loading="isTableLoading" :data="queriedData" style="width: 100%;"
				@selection-change="selectionChange">
				<el-table-column type="selection" width="55" fixed="left" height="500"></el-table-column>

				<el-table-column prop="sms_type" label="Template Type" sortable>
					<template slot-scope="scope">
						<p class="text-capitalize">{{ _gHlp.getValue(_gConst.smsType,scope.row.sms_type,'-') }}</p>
					</template>
				</el-table-column>

				<el-table-column prop="sms_content" label="Content" sortable>
					<template slot="header" slot-scope="scope">
						<span class="text-break">
							Title <br/>
							Content
						</span>
					</template>
					<template slot-scope="scope">
						<p class="text-capitalize">{{ scope.row.sms_title }}</p>
						<div v-html="scope.row.sms_content"></div>
					</template>
				</el-table-column>

				<!-- STATUS CREATED BY COLUMN -->
				<el-table-column prop="is_auto_send" label="Auto Send" sortable>
					<template slot-scope="scope">
						<b-icon icon="check-circle-fill" :variant="scope.row.is_auto_send == 1 ? 'success' : 'light'" font-scale="1.5" class="mx-2"></b-icon>
					</template>
				</el-table-column>

				<!-- STATUS CREATED AT COLUMN -->
				<el-table-column prop="created_at" label="Date Created" sortable>
					<template slot="header" slot-scope="scope">
						<span class="text-break">
							Create By <br/>
							Created Date
						</span>
					</template>
					<template slot-scope="scope">
						<p>{{ _gHlp.getValue(scope.row, 'created_by_detail.name', ' ') }}</p>
						<div v-if="scope.row.created_at">
							{{ scope.row.created_at | dateFormatString }}
						</div>
					</template>

				</el-table-column>

				<!-- STATUS ACTIONS COLUMN -->
				<el-table-column width="55" fixed="right">
					<template slot-scope="scope">
						<el-dropdown :tabindex="scope.row.id" class="py-2">
							<b class="el-dropdown-link">
								<b-icon icon="three-dots-vertical">
								</b-icon>
							</b>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="openModal(scope.row)">
									Edit
								</el-dropdown-item>
								<el-dropdown-item @click.native="deleteTemplate(scope.row.sms_template_id)">
									Delete
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>

				</el-table-column>

			</el-table>
		</div>

		<!-- FOOTER -->
		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
			<div class="">
				<p class="card-category">
					Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>
			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="pagination.total" @change="paginationChanged($event)">
			</base-pagination>
		</div>

		<SmsForm ref="modal_sms_form" :customerSubStatusList="customerSubStatusList"  @closeModal="closeModal"  />
	</b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import SmsForm from '@/views/AllSettings/TemplatePages/SmsTemplates/SmsForm'
import { cloneDeep } from 'lodash'
import { swal } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
	mixins: [clientPaginationMixin],
	components: {
		SmsForm,
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
	},
	data() {
		return {
			isTableLoading: true,
			propsToSearch: ['sms_title', 'sms_content'],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			TableColumn: [{
				type: 'selection'
			}],
			customerSubStatusList: [],
			tableData: [],
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			filters:{
				search_txt:''
			}
		}
	},
	created() {
		this.initComponent()
	},
	mounted() {},
	beforeUnmount() {},
	methods: {
		...mapActions(useCustomerStore, ['getCustomerStatus']),
		...mapActions(useMessagingStore, ['getSmsTemplates','deleteSmsTemplate']),
		async initComponent(){
			await this.getCustomerStsList();	
			this.getListing();
		},
		getCustomerStsList(){
			this.getCustomerStatus().then((resp) => {
				this.customerSubStatusList = resp
			})
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
			this.getListing()
		},
		getListing() {
			this.isTableLoading = true
			this.getSmsTemplates().then((resp) => {
				this.tableData = resp.map(template => {
					let matchedStatus = this.customerSubStatusList.find(status => status.status_id === template.customer_status_id);
					
					if (matchedStatus) {
						// Add the details to the template object
						return {
							...template,
							customer_status_details: matchedStatus
						};
					}
					
					return template;
				});
				this.isTableLoading = false
			}).catch((err)=>{
				this.isTableLoading = false
			})
		},
		deleteTemplate(sms_template_id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteSmsTemplates(sms_template_id).then((resp) => {
						this.getListing()
						_gNotif.notifySuccess('<b>Status: </b> - Successfully Deleted.')
						this.isTableLoading = false
					}).catch((err)=>{
						this.isTableLoading = false
					})
				}
			})
		},
		openModal(item = null) {
			this.$refs.modal_sms_form.show(cloneDeep(item))
		},
		closeModal(refresh=false) {
			if(refresh){
				this.getListing()
			}
		},
	}
}
</script>